import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean> | boolean {
    if (this.authService.loggedIn()) {
      return true;
    }
    window.location.href = `${environment.identity_url}/oauth2/authorize?scope=*&redirect_uri=${environment.base_url}/callback&response_type=token&client_id=1efe3b29-50fd-44fe-8fdc-27ff7106eac6`;
    return false;
  }
}